module.exports = __webpack_public_path__ + "static/heros1-e2a0442a0183895b252f97d2be879044.jpeg";